import { Skeleton } from "@pushpress/pushpress-ui";

export const ScheduleItemSkeleton = () => (
  <div className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-5 tw-bg-gray-100 tw-rounded-lg">
    <div className="tw-space-y-2">
      <Skeleton className="tw-h-4 tw-w-32" />
      <Skeleton className="tw-h-3 tw-w-24" />
    </div>
    <Skeleton className="tw-h-5 tw-w-5 tw-rounded-full" />
  </div>
);
